import api from './api'

export const contentAPI = {
  // Hero Content
  getHeroContent: () => api.get('/content/hero'),
  updateHeroContent: (data) => api.put('/content/hero', data),

  // Testimonials
  getTestimonials: () => api.get('/content/testimonials'),
  createTestimonial: (data) => api.post('/content/testimonials', data),
  updateTestimonial: (id, data) => api.put(`/content/testimonials/${id}`, data),
  deleteTestimonial: (id) => api.delete(`/content/testimonials/${id}`),

  // Features
  getFeatures: () => api.get('/content/features'),
  createFeature: (data) => api.post('/content/features', data),
  updateFeature: (id, data) => api.put(`/content/features/${id}`, data),
  deleteFeature: (id) => api.delete(`/content/features/${id}`),

  // FAQs
  getFAQs: () => api.get('/content/faqs'),
  createFAQ: (data) => api.post('/content/faqs', data),
  updateFAQ: (id, data) => api.put(`/content/faqs/${id}`, data),
  deleteFAQ: (id) => api.delete(`/content/faqs/${id}`),

  // Contact Info
  getContactInfo: () => api.get('/content/contact'),
  updateContactInfo: (data) => api.put('/content/contact', data),
}